import { Component, Input } from '@angular/core';
import { CaseData } from 'src/app/models/case-data.model';
import { CustomInputFieldComponent } from '../../custom-input-field/custom-input-field.component';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-bank-transfer',
  templateUrl: './bank-transfer.component.html',
  styleUrls: ['./bank-transfer.component.scss'],
  imports: [CustomInputFieldComponent, MatIconButton, TranslateModule],
})
export class BankTransferComponent {
  @Input({ required: true }) caseData!: CaseData;

  get bankAccount() {
    return this.caseData?.client_bankaccount;
  }

  copyToClipboard(e: HTMLInputElement) {
    e.select();
    e.setSelectionRange(0, 99999);

    document.execCommand('copy');
    window.getSelection().removeAllRanges();
  }
}
